export default __webpack_public_path__ + "static/media/Snd_TryZ.ab9dd2c9.mp3";